import * as React from 'react';

function SvgIconYes(props) {
  return (
    <svg width={16} height={12} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M2.643 4.906a1.27 1.27 0 00-1.795.003l-.476.476a1.27 1.27 0 00-.003 1.791L4.83 11.63c.248.247.572.37.897.37.325-.004.652-.127.901-.376l8.997-8.981A1.27 1.27 0 0015.63.845l-.477-.476a1.279 1.279 0 00-1.8.004L5.725 7.984 2.643 4.906z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgIconYes;
